// ============================================================
// Datei: src/pages/ResetPassword.jsx
// PURPOSE:
// Neues Passwort setzen, nachdem der Nutzer den Reset-Link
// aus der E-Mail geöffnet hat.
// ============================================================

import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Api from "../Api";

// eigenes CSS für diese Seite
import "../styles/resetPassword.css";

const ResetPassword = () => {

    // 🔍 Token aus URL lesen (z. B. .../reset?token=ABC123)
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get("token");

    // 🧠 Lokaler Zustand für Eingabefelder
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [message, setMessage] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    // 🔐 Passwort-Regeln: mind. 8 Zeichen, 1 Zahl, 1 Sonderzeichen
    const isValidPassword = (pw) =>
        /^(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/.test(pw);

    // Stimmen beide Felder überein?
    const passwordsMatch = password && password === passwordConfirm;

    const allValid = isValidPassword(password) && passwordsMatch;

    // 📩 Formular absenden
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!allValid || submitting) return;

        setSubmitting(true);
        setMessage(null);

        try {
            await Api.post("/auth/reset-password", {
                token,
                newPassword: password
            });

            setMessage({
                type: "success",
                text: "Passwort erfolgreich geändert! Du wirst weitergeleitet…"
            });

            // ⏳ Nach kurzer Zeit zurück zum Login
            setTimeout(() => navigate("/login"), 2000);

        } catch (error) {
            setMessage({
                type: "error",
                text: error.response?.data?.error || "Fehler beim Ändern des Passworts."
            });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div
            className="reset-container"
            style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/backgrounds/background_resetPassword.png)`
            }}
        >
            <form className="reset-form" onSubmit={handleSubmit}>

                <h2 className="reset-heading">Neues Passwort setzen</h2>

                {/* Erfolgs- oder Fehlermeldung */}
                {message && (
                    <div
                        className={
                            message.type === "success"
                                ? "reset-success"
                                : "reset-error"
                        }
                    >
                        {message.text}
                    </div>
                )}

                <label className="reset-label">Neues Passwort</label>
                <input
                    type="password"
                    className={`reset-input ${
                        password
                            ? isValidPassword(password)
                                ? "input-valid"
                                : "input-invalid"
                            : ""
                    }`}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="mind. 8 Zeichen, 1 Zahl, 1 Sonderzeichen"
                    required
                />

                <label className="reset-label">Passwort bestätigen</label>
                <input
                    type="password"
                    className={`reset-input ${
                        passwordConfirm
                            ? passwordsMatch
                                ? "input-valid"
                                : "input-invalid"
                            : ""
                    }`}
                    value={passwordConfirm}
                    onChange={(e) => setPasswordConfirm(e.target.value)}
                    placeholder="Passwort wiederholen"
                    required
                />

                {!passwordsMatch && passwordConfirm && (
                    <p className="validation-error">Passwörter stimmen nicht überein.</p>
                )}

                <button className="reset-button" disabled={!allValid || submitting}>
                    {submitting ? "Speichere…" : "Passwort ändern"}
                </button>
            </form>
        </div>
    );
};

export default ResetPassword;
